





























import { Component, Prop } from "vue-property-decorator";

import AppVue from "@/AppVue.vue";
import { SimpleLookupModel } from "@/core/models";

@Component
export default class SkillAmountsCpt extends AppVue {
  @Prop() rowText: string;
  @Prop() strategyLevels: SimpleLookupModel[];
  @Prop() model: Array<undefined | boolean>;
  @Prop({ default: false }) disabled: boolean;

  internalModel = [this.model];

  getHeading(label: string) {
    return label.split("(")[0];
  }

  getSubHeading(label: string) {
    return `(${label.split("(")[1]}`;
  }
}
